<template>
    <div v-if="currentPhoto" class="fullview-container" @mouseenter="() => {this.showFullViewControls = true}" @mouseleave="() => {this.showFullViewControls = false}">
        <div v-if="currentPhoto" class="fullview-close-button" @click="close()">ESC {{$t('message.close')}}</div>
        <div class="fullview-image">
            <div class="img-container">
                <img ref="photo" :src="currentPhoto.path.indexOf('http') === -1 ? context.storageEndpoint + currentPhoto.path : currentPhoto.path" :class="{ 'transform-center': needTransformCenter}" @load="handleResize" /> 
            </div>
        </div>
        <transition name="fade">
            <div v-if="this.showFullViewControls" class="fullview-text">{{currentPhoto.text}}</div>
        </transition>
        <transition name="fade">
            <div v-if="this.showFullViewControls && this.canGoBackward()" class="fullview-control-button fullview-backward-button" @click="this.backward">
                <img class="backward-icon" src="/img/backward.png" />
            </div>
        </transition>
        <transition name="fade">
            <div v-if="this.showFullViewControls && this.canGoForward()" class="fullview-control-button fullview-forward-button" @click="this.forward">
                <img class="forward-icon" src="/img/forward.png" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        context: { type: Object, required: true },
        photos: { type: Array, required: true }
    },
    data() {
        const isATouchingDevice = ('ontouchstart' in window);
        return {
            showFullViewControls: isATouchingDevice,
            currentPhoto: this.photos[0],
            parentNode: null,
            needTransformCenter: false
        }
    },
    mounted() {
        window.addEventListener('keyup', this.handleKeyup, true);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        // move el to body makes my life easier without handling position fixed and overflow shit happened on mobile safari

        let node = this.$el;
        this.parentNode = node.parentNode;
        this.parentNode.removeChild(node);
        $('body').append(node);

        const scrollElm = document.scrollingElement;
        scrollElm.classList.add('overflow-hidden');
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyup, true);
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        close() {
            let node = this.$el;
            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
            $(this.parentNode).append(node);
            this.$nextTick(() => {
                this.$emit('close');
            })

            const scrollElm = document.scrollingElement;
            scrollElm.classList.remove('overflow-hidden');
        },
        selectPhoto(photo) {
            this.currentPhoto = photo;
        },
        handleKeyup(event) {
            switch (event.keyCode) {
                case 27:
                    this.close();
                    break;
                case 37:
                    if (this.canGoBackward()) {
                        this.backward();
                    }
                    break;
                case 39:
                    if (this.canGoForward()) {
                        this.forward();
                    }
                    break;
                default:
                    break;
            }
            event.stopPropagation();
            event.preventDefault();
        },
        handleResize() {
            const photoEl = this.$refs.photo;
            const photoRect = photoEl.getBoundingClientRect();
            this.needTransformCenter = false;

            if (photoRect.width > photoRect.height) {
                this.needTransformCenter = true;
            } else if (photoRect.height < window.innerHeight) {
                this.needTransformCenter = true;
            }
        },
        // ++
        canGoForward() {
            let currentPhotoIndex = this.photos.indexOf(this.currentPhoto);
            return currentPhotoIndex < this.photos.length - 1;
        },

        // --
        canGoBackward() {
            let currentPhotoIndex = this.photos.indexOf(this.currentPhoto);
            return currentPhotoIndex > 0;
        },

        forward() {
            let currentPhotoIndex = this.photos.indexOf(this.currentPhoto);
            this.currentPhoto = this.photos[currentPhotoIndex + 1];
        },

        backward() {
            let currentPhotoIndex = this.photos.indexOf(this.currentPhoto);
            this.currentPhoto = this.photos[currentPhotoIndex - 1];
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/_mixins.scss';

    .fullview-container {
        position:fixed;
        top:0px;
        left:0px;
        right:0px;
        bottom: 0px;
        padding: 8px;
        background: #000000DD;
        z-index: 2200000000;
    }

    .fullview-control-button {
        width: 25%;
        top: 0;
        bottom: 0;
        position: absolute;
        cursor: pointer;
    }

    .fullview-backward-button {
        left: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    .fullview-forward-button {
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }

    .fullview-image {
        position: absolute;
        left: 0px;
        right: 0px;
        bottom: 0px;
        top: 0px;

        .img-container {
            width: 100%;
            height: 100%;
            overflow: auto;
            text-align: center;
            position: relative;
        }

        img {
            max-width: 100%;

            &.transform-center {
                position: relative;
                top: 50%;
                transform: translateY(-50%);
            }
        }

    }

    .fullview-close-button {
        position: fixed;
        top: 1px;
        right: 1px;
        background-color: #333;
        color: #F0F0F0;
        font-size: 16px;
        padding: 4px 8px;
        cursor: pointer;
        z-index: 1000;
    }

    .fullview-close-button:hover {
        background-color: #444;
    }

    .fullview-text {
        color: white;
        font-size: 18px;
        padding: 1em;
        background: linear-gradient(rgba(0, 0, 0, .5), rgba(0,0,0,0));
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }

</style>